import { render, staticRenderFns } from "./AddNewEmpCategory.vue?vue&type=template&id=43dcd8a7&scoped=true"
import script from "./AddNewEmpCategory.vue?vue&type=script&lang=js"
export * from "./AddNewEmpCategory.vue?vue&type=script&lang=js"
import style0 from "./AddNewEmpCategory.vue?vue&type=style&index=0&id=43dcd8a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dcd8a7",
  null
  
)

export default component.exports